import { NORMALIZATION_OPTIONS } from 'src/constants/forms';

import messages from './messages';

export const normalizationSelectors = [
  {
    label: messages.none,
    value: NORMALIZATION_OPTIONS.NONE,
  },
  {
    label: messages.volume,
    value: NORMALIZATION_OPTIONS.VOLUME,
  },
  {
    label: messages.concentration,
    value: NORMALIZATION_OPTIONS.CONCENTRATION,
  },
  {
    label: messages.volumeAndConcentration,
    value: NORMALIZATION_OPTIONS.CONCENTRATION_VOLUME,
  },
];
